import React from "react";

import "./Intro.css"


function Intro() {
    return (
        <section className="intro-content">
            <h1 className="intro-content__title">Welcome to Cyber-Dater</h1>
            <h2 className="intro-content__subheading">A Passionate Cyber Web Reality Experience</h2>
            
            <p>
                Find your e-lover in cyber space. Take many beautiful partners in your journey to exotic experiences, and let your immersive web reality drive you crazy. Get to know them as the sparks fly, and you will be certain it is better than the real thing!
            </p>

            <p>
                To begin with, select an e-date partner and location to jump start your love life.
            </p>
        </section>
    );
}

export default Intro;